module.exports = __webpack_public_path__ + "static/media/28x152.2cd62998.png";